import { render, staticRenderFns } from "./ColorMonitor.vue?vue&type=template&id=740bc96a&scoped=true&"
import script from "./ColorMonitor.vue?vue&type=script&lang=js&"
export * from "./ColorMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ColorMonitor.vue?vue&type=style&index=0&id=740bc96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740bc96a",
  null
  
)

export default component.exports